import React, { useEffect, useState } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { registerToken, redirectUserToPdP } from 'utils/auth-token';

export function Auth() {
  const [isReady, setReady] = useState(false);
  const [tokenError, setTokenError] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      registerToken(token).then(() => setReady(true));
    } else {
      setTokenError(true);
    }
  }, [searchParams]);

  if (tokenError) {
    redirectUserToPdP();
    return <p>Sem token de acesso.</p>
  }

  if (!isReady) {
    return <p>Aguarde!</p>
  }
  
  return <Navigate to={'/'} />
}

export const ACCESS_TOKEN = 'simulador-token-storage';
export const REFRESH_TOKEN = 'simulador-refresh-token-storage';
export const SYSTEM_NAME = 'MeuPersonalizador';
